module.exports = __webpack_public_path__ + "img/teacher02.c843ecb6.jpeg";